// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__GfYm5","content":"profile_content__ZVbdK"};